import { localDate, type LocalDate } from '@tahi/core';
import { useMemo } from 'react';
import { useData } from '../../data/hooks';
import * as repo from '../../data/repos/weight';
import { useQuery } from '../../data/useQuery';
import { useNow } from '../../ui/useNow';
import { buildWeightOverview, type WeightOverview } from './overview';

export const WEIGHT_BASE = '/m/weight';

/** Today in the user's zone, refreshed every minute so the day rolls over at local midnight. */
export function useWeightToday(): LocalDate {
  const now = useNow(60_000);
  return localDate(now, useData().tz);
}

/** Every live weigh-in and the settings, derived; undefined while loading. */
export function useWeightOverview(): WeightOverview | undefined {
  const { userId } = useData();
  const today = useWeightToday();
  const { data } = useQuery(
    repo.WEIGHT_TABLES,
    async (db) => ({
      entries: await repo.listWeightEntries(db, userId),
      settings: await repo.getWeightSettings(db, userId),
    }),
    [userId],
  );
  return useMemo(
    () => (data ? buildWeightOverview(data.entries, data.settings, today) : undefined),
    [data, today],
  );
}
